import { Observable, Subject } from 'rxjs';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { snFadeIn, snFadeInDown } from '@lib/common/animations';

import { SnChannel } from '../../models/channel.model';
import { SnChatService } from '../../services/chat.service';

@Component({
  selector: 'sn-channels-dialog',
  templateUrl: './channels-to-share-dialog.component.html',
  styleUrls: ['./channels-to-share-dialog.component.scss'],
  animations: [snFadeIn, snFadeInDown],
})
export class ChannelsToShareDialogComponent implements OnDestroy, OnInit {
  public channels: SnChannel[] = [];

  public loading: boolean = true;

  public chatLoaded$ = new Observable<boolean>();

  public channel: SnChannel;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _dialogRef: MatDialogRef<ChannelsToShareDialogComponent>,
    private readonly _chat: SnChatService,
  ) {}

  public ngOnInit(): void {
    this.chatLoaded$ = this._chat.chatIsReady$;
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public cancel(): void {
    this._dialogRef.close();
  }

  public send(): void {
    this._dialogRef.close(this.channel);
  }

  public selectChannel(channel: SnChannel): void {
    this.channel = channel;
  }
}
